// Dependencies
require("webstrap/scaffolding");

// JavaScript
// Import loader is important to expose jQuery
require("imports?jQuery=jquery!bootstrap-sass/assets/javascripts/bootstrap/transition.js");
require("imports?jQuery=jquery!bootstrap-sass/assets/javascripts/bootstrap/dropdown.js");

// Styles
require("./dropdowns.scss");



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/webstrap/dropdowns/index.js
// module id = 269
// module chunks = 0